(function(){
  function initSlider(root){
    var track=root.querySelector('.dv-track');if(!track||track.dataset.dvInit)return;track.dataset.dvInit=1;
    var prev=root.querySelector('[data-dv-prev]'),next=root.querySelector('[data-dv-next]'),dots=root.querySelector('.dv-dots');
    var items=track.children;
    function step(){return items.length>1?items[1].offsetLeft-items[0].offsetLeft:track.clientWidth}
    function update(){
      var max=track.scrollWidth-track.clientWidth-2;
      if(prev)prev.disabled=track.scrollLeft<=2;
      if(next)next.disabled=track.scrollLeft>=max;
      if(dots){var i=Math.round(track.scrollLeft/step());[].forEach.call(dots.children,function(d,k){d.classList.toggle('on',k===i)})}
    }
    if(dots){dots.innerHTML='';var vis=Math.max(1,Math.round(track.clientWidth/step()));var n=Math.max(1,items.length-vis+1);for(var k=0;k<n;k++){dots.appendChild(document.createElement('i'))}}
    if(prev)prev.addEventListener('click',function(){track.scrollBy({left:-step(),behavior:'smooth'})});
    if(next)next.addEventListener('click',function(){track.scrollBy({left:step(),behavior:'smooth'})});
    track.addEventListener('scroll',function(){window.requestAnimationFrame(update)},{passive:true});
    update();
  }
  function initTabs(root){
    if(root.dataset.dvInit)return;root.dataset.dvInit=1;
    var btns=root.querySelectorAll('[data-dv-tab]');
    btns.forEach(function(b){b.addEventListener('click',function(){
      var t=b.getAttribute('data-dv-tab');
      btns.forEach(function(x){x.classList.toggle('on',x===b)});
      root.querySelectorAll('[data-dv-pane]').forEach(function(p){p.classList.toggle('on',p.getAttribute('data-dv-pane')===t)});
      root.querySelectorAll('[data-dv-pane].on [data-dv-slider]').forEach(function(s){var tr=s.querySelector('.dv-track');if(tr){delete tr.dataset.dvInit}initSlider(s)});
    })});
  }
  function initVideos(root){
    root.querySelectorAll('.dv-vid').forEach(function(v){
      if(v.dataset.dvInit)return;v.dataset.dvInit=1;
      var vid=v.querySelector('video');
      v.addEventListener('click',function(){
        if(vid.paused){root.querySelectorAll('.dv-vid video').forEach(function(o){if(o!==vid){o.pause();o.parentNode.classList.remove('playing')}});vid.muted=false;vid.play();v.classList.add('playing')}
        else{vid.pause();v.classList.remove('playing')}
      });
    });
  }
  function initTimers(){
    document.querySelectorAll('[data-dv-timer]').forEach(function(el){
      if(el.dataset.dvInit)return;el.dataset.dvInit=1;
      var h=el.querySelector('[data-h]'),m=el.querySelector('[data-m]'),s=el.querySelector('[data-s]');
      function pad(n){return n<10?'0'+n:''+n}
      function tick(){var now=new Date(),end=new Date(now);end.setHours(23,59,59,999);var d=Math.max(0,Math.floor((end-now)/1000));h.textContent=pad(Math.floor(d/3600));m.textContent=pad(Math.floor(d%3600/60));s.textContent=pad(d%60)}
      tick();setInterval(tick,1000);
    });
  }
  function init(){
    document.querySelectorAll('[data-dv-slider]').forEach(function(s){if(s.offsetParent!==null)initSlider(s)});
    document.querySelectorAll('[data-dv-tabs]').forEach(initTabs);
    document.querySelectorAll('.dv-vids').forEach(initVideos);
    initTimers();
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init)}else{init()}
  document.addEventListener('shopify:section:load',init);
})();
